import React, { useEffect, useState } from "react";
import Loading from "../common/loading";
import Markdown from "../common/markdown";

import RiskPopupImp from "./risk-popup";
import ImplementationPopupImp from "./implementation-popup";
import "./air.css";

const AIRPagewithPopups = ({ description: pageContent }) => {
  const [isLoading, setLoading] = useState(true);
  const [displayContent, setContent] = useState("");
  const [popupDescription, setPopupDescription] = useState("");
  const [popupType, setPopupType] = useState("");
  const [conclusion, setConclusion] = useState("");
  const [grid, setGridContent] = useState("");

  useEffect(() => {
    console.log("AIRPagewithPopups mounted");
    // console.log("props:", pageContent);

    // Ensure page content is available
    if (pageContent.content) {
      setContent(pageContent.content);
      setLoading(false);
    }

    // Set popup type
    if (pageContent.popup) {
      let popupContent = "";
      let popupJSON = JSON.parse(pageContent.popup);
      if (popupJSON.risk) {
        setPopupType("risk");
        popupContent = popupJSON.risk;
      } else if (popupJSON.implementation) {
        setPopupType("implementation");
        popupContent = popupJSON.implementation;
      } else {
        setPopupType("risk");
        popupContent = popupJSON.content;
      }
      setPopupDescription(popupContent);
      // setShowPopup(true);
      setLoading(false);
    }
    if (pageContent.metadata) {
      let metadata = JSON.parse(pageContent.metadata);
      if (metadata.conclusion) {
        setConclusion(metadata.conclusion);
      }
      if (metadata.grid) {
        setGridContent(metadata.grid);
      }
    }
  }, [pageContent]);

  return (
    <React.Fragment>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Markdown className="air-content" children={displayContent} />

          {/* 04 Risk popup container */}
          {popupDescription && popupType === "risk" && (
            <RiskPopupImp popupDescription={popupDescription} />
          )}
          {/* 05 Implementations popup container */}
          {popupDescription && popupType === "implementation" && (
            <ImplementationPopupImp popupDescription={popupDescription} />
          )}

          {conclusion && <div className="conclusion-section">{conclusion}</div>}
        </>
      )}
    </React.Fragment>
  );
};

export default AIRPagewithPopups;
